/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Right_Aria_LabelInputs */

const en_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top right`)
};

const fr_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En haut a droite`)
};

const de_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben rechts`)
};

const it_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto a destra`)
};

const ru_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вверху справа`)
};

const es_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba a la derecha`)
};

const zh_cn2_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上角`)
};

const ja_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上`)
};

const hi_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक तरह से ऊपर`)
};

const pt_pt2_position_top_right_aria_label = /** @type {(inputs: Position_Top_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto superior direito`)
};

/**
* | output |
* | --- |
* | "Top right" |
*
* @param {Position_Top_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_right_aria_label = /** @type {((inputs?: Position_Top_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_top_right_aria_label(inputs)
	if (locale === "de") return de_position_top_right_aria_label(inputs)
	if (locale === "it") return it_position_top_right_aria_label(inputs)
	if (locale === "ru") return ru_position_top_right_aria_label(inputs)
	if (locale === "es") return es_position_top_right_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_top_right_aria_label(inputs)
	if (locale === "ja") return ja_position_top_right_aria_label(inputs)
	if (locale === "hi") return hi_position_top_right_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_top_right_aria_label(inputs)
	return en_position_top_right_aria_label(inputs)
});